import styled from 'styled-components';

export const Container = styled.div`
  .close {
    position: absolute;
    right: 12px;
    top: 5px;
    z-index: 11;
    color: ${(props) => props.theme.$white};
  }
`;
